@use "@fukuri-admins/ui/layout" as *;

.root {
  width: 1112px;
  margin: 28px auto 0;
}

.header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 32px;
}

.title {
  font-weight: 400;
  font-size: 48px;
}

.description {
  font-size: 24px;
}

.cardWrapper {
  display: flex;
  flex-wrap: wrap;
  padding: 28px 16px 0;
}

.card {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 360px;
  height: 530px;
  border: 1px solid border("Quinary");
}
